import { Route, Routes, NavLink, Link } from 'react-router-dom';
import { MDXProvider } from '@mdx-js/react';

import Introduction from './content/introduction.mdx';
import Authentication from './content/authentication.mdx';
import Tokenization from './content/tokenization.mdx';
import Postbacks from './content/postbacks.mdx';
import Idempotency from './content/idempotency.mdx';
import TestMode from './content/test-mode.mdx';
import Errors from './content/errors.mdx';
import Changelog from './content/changelog.mdx';
import { Reference } from './pages/Reference';

const NAV: { label: string; items: { to: string; label: string }[] }[] = [
  {
    label: 'Getting Started',
    items: [
      { to: '/', label: 'Introduction' },
      { to: '/authentication', label: 'Authentication' },
      { to: '/test-mode', label: 'Test mode' },
    ],
  },
  {
    label: 'Core flows',
    items: [
      { to: '/tokenization', label: 'Card tokenization' },
      { to: '/postbacks', label: 'Postbacks' },
      { to: '/idempotency', label: 'Idempotency' },
    ],
  },
  {
    label: 'Reference',
    items: [
      { to: '/reference', label: 'API reference' },
      { to: '/errors', label: 'Error codes' },
      { to: '/changelog', label: 'Changelog' },
    ],
  },
];

const mdxComponents = {
  // Tighten heading anchors etc. — Scalar provides its own component set on
  // the /reference route. For MDX guides we keep defaults.
};

export function App() {
  return (
    <div className="layout">
      <aside className="sidebar">
        <Link to="/" className="brand">
          <span className="logo">N4</span>
          <span>Payments — Docs</span>
        </Link>
        {NAV.map((group) => (
          <div key={group.label} className="group">
            <div className="group-label">{group.label}</div>
            {group.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        ))}
      </aside>

      <main className="content">
        <MDXProvider components={mdxComponents}>
          <Routes>
            <Route path="/" element={<Introduction />} />
            <Route path="/authentication" element={<Authentication />} />
            <Route path="/tokenization" element={<Tokenization />} />
            <Route path="/postbacks" element={<Postbacks />} />
            <Route path="/idempotency" element={<Idempotency />} />
            <Route path="/test-mode" element={<TestMode />} />
            <Route path="/errors" element={<Errors />} />
            <Route path="/changelog" element={<Changelog />} />
            <Route path="/reference" element={<Reference />} />
          </Routes>
        </MDXProvider>
      </main>
    </div>
  );
}
